import { httpPost } from "utils/httpRequest"

const listDsarRequests = async (params) => {
  const resp = await httpPost("admin/member-dsar/list", params)
  return resp.data
}

const createDsarRequest = async (params) => {
  const resp = await httpPost("admin/member-dsar/create", params)
  return resp.data
}

const getDsarRequestDetail = async ({ id }) => {
  const resp = await httpPost("admin/member-dsar/queryDetail", { id })
  return resp.data
}

const approveDsarRequest = async ({ id, notes }) => {
  const resp = await httpPost("admin/member-dsar/approve", { id, notes })
  return resp.data
}

const executeDsarErase = async ({ id, notes }) => {
  const resp = await httpPost("admin/member-dsar/executeErase", { id, notes })
  return resp.data
}

const cancelDsarRequest = async ({ id, notes }) => {
  const resp = await httpPost("admin/member-dsar/cancel", { id, notes })
  return resp.data
}

export {
  listDsarRequests,
  createDsarRequest,
  getDsarRequestDetail,
  approveDsarRequest,
  executeDsarErase,
  cancelDsarRequest,
}
